import cn from 'clsx';
import { FC, useContext } from 'react';

import Icon from '../../Icon';

import s from './Radio.module.scss';
import RadioGroupContext from './context';
import { RadioChangeEvent, RadioProps } from './interfaces';

const Radio: FC<React.PropsWithChildren<React.PropsWithChildren<RadioProps>>> = (props) => {
  const groupContext = useContext(RadioGroupContext);

  const { children, ...restProps } = props;
  const radioProps: RadioProps = { ...restProps };

  const onChange = (e: RadioChangeEvent) => {
    restProps.onChange?.(e);
    groupContext?.onChange?.(e);
  };

  if (groupContext) {
    radioProps.onChange = onChange;
    radioProps.checked = restProps?.value?.toString() === groupContext?.value?.toString();
    radioProps.disabled = restProps?.disabled || groupContext?.disabled;
  }

  return (
    <label
      className={cn(s.group__label, {
        [s['group--disabled'] as string]: radioProps?.disabled
      })}
    >
      <Icon
        color={radioProps?.checked ? 'violet.600' : 'gray.300'}
        className={radioProps?.checked ? s['group__label--checked'] : ''}
        type={radioProps?.checked ? 'check-solid' : 'check-empty'}
        size={28}
      />
      <input className={s.group__label__radio} type="radio" disabled={restProps?.disabled} {...radioProps} />
      {children && <span>{children}</span>}
    </label>
  );
};
export default Radio;
